<template>
    <div class="verify__wrap">
        <template v-if="pageLoading">
            <PageSpinner />
        </template>
        <template v-else-if="pageErr">
            <EmptyPage 
                state="error_custom" 
                title="Unable to proceed with payment"
                btn-state="custom" 
                class="verify__wrap__empty"
                subtitle="We are unable to proceed with billing. To re-initiate your billing, go to settings > payments & billings"
                @action="goBack"
            >
                <template #button>
                    <BaseButton 
                        label="Go to dashboard" 
                        @submit="goBack"
                    />
                </template>
            </EmptyPage>
        </template>
    </div>
</template>

<script>
import { BaseButton, PageSpinner, EmptyPage } from "@/components/ui/index";

export default {
    name: "InitiatePaidPlan",

    components: {
        BaseButton,
        PageSpinner,
        EmptyPage,
    },

    beforeRouteEnter(to, from, next) {        
        next(async(vm) => {            
            if (to.name === "initiate-payments") { 
                const initiatePaidPlan = vm.$store.getters["app/initiatePaidPlan"];
               
                if (!initiatePaidPlan) {
                    return vm.$router.push({ name: "reports", query: { type: "clients", range: "1_year" } });
                }
            }
        });
    },

    props: {
        title: { type: String, default: "" },
        desc: { type: String, default: "" },
        highlight: { type: String, default: "" },
        btnLabel: { type: String, default: "Reload" },
        iconName: { type: String, default: "reload" },
    },

    data() {
        return {
            pageLoading: true,
            pageErr: false,
            pageErrMsg: "",
        };
    },

    computed: {
        selectedPlan() {
            return this.$store.getters["app/selectedPlan"];
        },

        profile() {
            return this.$store.getters["auth/profile"];
        },

        initiatePaidPlan() {
            return this.$store.getters["app/initiatePaidPlan"];
        },
    },

    async mounted() {
        await this.loadRequests();
    },

    methods: {
        async handleFetchUserProfile() {
            try {
                await this.$store.dispatch("auth/fetchProfile", { refresh: true });
            } catch (error) {
                throw error;
            }
        }, 

        async handleSubscription() {
            try {
                const payload = {
                    email: this.profile.email,
                    targetPlan: this.selectedPlan,
                    callback_url: `${window.location.origin}/payments/verify?type=new`,
                    metadata: JSON.stringify({
                        cancel_action: `${window.location.origin}/dashboard/reports?type=clients&range=1_year`,
                    }),
                };

                localStorage.setItem("z_sub_page", "hdguod");
                sessionStorage.setItem("z:t_p", this.selectedPlan);
                sessionStorage.setItem("z:t_type", "dcdahsygh");
                sessionStorage.setItem("z:t_d", true);

                const data = await this.$store.dispatch("subscription/updateSubscriptionPlan", payload);

                if (!data?.url) {
                    this.$toast.error("Unable to process your request. Please try again.");
                    return;
                } 

                this.$store.dispatch("app/setInitiatePaidPlan", false);
    
                window.location.href = data.url;
            } catch (error) {
                throw error;
            }
        },

        async loadRequests() {
            try {
                await this.handleFetchUserProfile();
                await this.handleSubscription();
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;   
                
                console.log({ errMsg });
                
                this.pageErrMsg = errMsg;
                this.pageErr = true;
            } finally {
                this.pageLoading = false;
            }
        },

        goBack() {
            return this.$router.push({ name: "reports", query: { type: "clients", range: "1_year" } });
        },
    },
};
</script>

<style lang="scss" scoped>
    .billing-page {
        min-height: 100vh;
        padding: 0.5rem 2rem 2rem;

        .max-w-page {
            max-width: 80%;
            margin-right: auto;
            margin-left: auto;
            justify-content: space-between;

            .left {
                margin-right: 7rem;
            }
        }
    }
</style>